import { render, staticRenderFns } from "./template4.vue?vue&type=template&id=a8c8f688&"
import script from "./template4.vue?vue&type=script&lang=ts&"
export * from "./template4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports